import { CongSetting, CongSettings } from "../../../types/scheduling/settings";
import { useTranslation } from "react-i18next";
import { canUpdateCongSettings, CheckBox, DDMnumbers, TextInput } from "./settings";
import HourglassGlobals from "../../../helpers/globals";
import { Permission } from "../../../types/permission";

export const SettingsAVA = (props: { settings: CongSettings; setSettings: (set: CongSettings) => void }) => {
  const { t } = useTranslation();
  const hasAV = canUpdateCongSettings() || HourglassGlobals.permissions.has(Permission.UpdateAVSchedules);
  const hasAttendant = canUpdateCongSettings() || HourglassGlobals.permissions.has(Permission.UpdateAttendantSchedules);
  return (
    <div>
      <DDMnumbers
        settingKey={CongSetting.NumberOfMicAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={6}
        allowZero
        disabled={!hasAV}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfAttendantAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={6}
        disabled={!hasAttendant}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfZoomAttendantAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={3}
        allowZero
        disabled={!hasAttendant}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfSecurityAttendantAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={6}
        allowZero
        disabled={!hasAttendant}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfStageAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={3}
        allowZero
        disabled={!hasAV}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfConsoleAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={3}
        allowZero
        disabled={!hasAV}
      />
      <DDMnumbers
        settingKey={CongSetting.NumberOfVideoAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={3}
        allowZero
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.VideoLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        placeholder={t("schedules.console.video")}
        hidden={props.settings.number_of_video_assignments < 1}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.VideoLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_video_assignments < 2}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.VideoLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_video_assignments < 3}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.ConsoleLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        placeholder={t("schedules.console.audio")}
        hidden={props.settings.number_of_console_assignments < 1}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.ConsoleLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_console_assignments < 2}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.ConsoleLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_console_assignments < 3}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        hidden={props.settings.number_of_mic_assignments < 1}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_mic_assignments < 2}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_mic_assignments < 3}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel4}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={4}
        hidden={props.settings.number_of_mic_assignments < 4}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel5}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={5}
        hidden={props.settings.number_of_mic_assignments < 5}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.MicLabel6}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={6}
        hidden={props.settings.number_of_mic_assignments < 6}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.StageLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        hidden={props.settings.number_of_stage_assignments < 1}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.StageLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_stage_assignments < 2}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.StageLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_stage_assignments < 3}
        disabled={!hasAV}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        hidden={props.settings.number_of_attendant_assignments < 1}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_attendant_assignments < 2}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_attendant_assignments < 3}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel4}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={4}
        hidden={props.settings.number_of_attendant_assignments < 4}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel5}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={5}
        hidden={props.settings.number_of_attendant_assignments < 5}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.AttendantLabel6}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={6}
        hidden={props.settings.number_of_attendant_assignments < 6}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.ZoomAttendantLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        hidden={props.settings.number_of_zoom_attendant_assignments < 1}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.ZoomAttendantLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_zoom_attendant_assignments < 2}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.ZoomAttendantLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_zoom_attendant_assignments < 3}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel1}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={1}
        hidden={props.settings.number_of_security_attendant_assignments < 1}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel2}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={2}
        hidden={props.settings.number_of_security_attendant_assignments < 2}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel3}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={3}
        hidden={props.settings.number_of_security_attendant_assignments < 3}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel4}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={4}
        hidden={props.settings.number_of_security_attendant_assignments < 4}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel5}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={5}
        hidden={props.settings.number_of_security_attendant_assignments < 5}
        disabled={!hasAttendant}
      />
      <TextInput
        settingKey={CongSetting.SecurityAttendantLabel6}
        settings={props.settings}
        setSettings={props.setSettings}
        pill={6}
        hidden={props.settings.number_of_security_attendant_assignments < 6}
        disabled={!hasAttendant}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.AVAScheduleWeekly}
        settings={props.settings}
        setSettings={props.setSettings}
      />
    </div>
  );
};
